// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1793275288571
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/views/Viandas/PedidosViandas/ModalConfirmacion.scss
// module id = ./src/views/Viandas/PedidosViandas/ModalConfirmacion.scss
// module chunks = 0